import Favorite from '@mui/icons-material/FavoriteOutlined'
import React from 'react'
import { addFavorite, deleteFavorite } from '../../../store/user/actions'
import { isTokenValid } from '../../../store/user/helpers'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'

interface IProps {
  isFavorite: boolean
  id: number
  type: 'Community' | 'MobileHome'
  favid: number
}

const FavoriteIcon: React.FC<IProps> = (props: IProps) => {
  const { isFavorite, id, type, favid } = props
  const showIcon = useAppSelector((state) => isTokenValid(state.user.jwt))
  const dispatch = useAppDispatch()
  return (
    <div
      className={`listingCell__preview_cell_icons${
        isFavorite ? `_favorite` : ``
      }`}
    >
      {showIcon ? (
        <Favorite // tslint:disable-next-line: jsx-no-lambda
          onClick={(e) => {
            e.stopPropagation()
            if (isFavorite) {
              dispatch(deleteFavorite(favid))
            } else {
              dispatch(addFavorite({ id, type }))
            }
          }}
        />
      ) : null}
    </div>
  )
}

export default FavoriteIcon
